<template>
  <div class="progress">
    <div class="banner"></div>
    <div class="profile">
      <div class="profile-header">
        <div class="title">
          <div class="cont_tit">
            <p>关注企业/收藏岗位</p>
            <span>Follow enterprises/Collect positions</span>
          </div>
          <div class="crumb">
            <span>当前位置：</span>
            <a href="../" target="_self" title="首页" class="CurrChnlCls"
              >首页</a
            >&gt;<a
              href=""
              target="_self"
              title="关注企业/收藏岗位"
              class="CurrChnlCls"
              >关注企业/收藏岗位</a
            >
          </div>
        </div>
      </div>
      <div class="profile-conter">
        <ul class="job-tab">
          <li
            v-for="(item, index) in tabs"
            :key="index"
            class="tab-item"
            :class="{ 'item--active': Mode == item }"
            @click="toggleLoginMode(item)"
          >
            {{ item }}
          </li>
        </ul>
      </div>
      <div class="resumeForm">
        <div class="ant-spin-nested-loading">
          <div class="ant-spin-container">
            <div class="content" v-if="Mode == '关注企业'">
              <ul class="content-list" v-if="dataList.length > 0">
                <li
                  class="recommend-job-item"
                  v-for="(item, index) in dataList"
                  :key="index"
                >
                  <a
                    :href="'/companyDetail/' + item.reCompanyId"
                    target="_blank"
                    class="company-t"
                  >
                    <img
                      v-if="item.reCompanyLogo"
                      :src="item.reCompanyLogo"
                      alt=""
                      class="company-logo1"
                    />
                    <div
                      v-else
                      class="company-title1"
                      :style="{
                        backgroundColor: getColorById(item.reCompanyId),
                      }"
                    >
                      {{ item.reCompanyName.slice(0, 4) }}
                    </div>
                    <div class="company-top-container">
                      <div class="company-top">
                        {{ item.reCompanyName }}
                      </div>
                      <div class="company-bottom substring">
                        <span class="tag" v-if="item.industry">{{
                          item.industry
                        }}</span
                        ><span class="tag" v-if="item.enterpriseNature">{{
                          item.enterpriseNature
                        }}</span
                        ><span class="tag" v-if="item.enterpriseScale">{{
                          item.enterpriseScale
                        }}</span>
                        <span class="tag" v-if="item.groupName">{{
                          item.groupName
                        }}</span>
                      </div>
                    </div>
                  </a>
                </li>
              </ul>
              <div class="empty-page" v-else>
                <div class="empty-tip">
                  您还没有关注的企业，建议您主动出击！
                </div>
                <button type="button" class="ant-btn ant-btn-primary empty-btn">
                  <router-link to="/companys">搜索企业</router-link>
                </button>
              </div>
              <!-- 分页器 -->
              <div class="pagination-wrapper">
                <pagination
                  v-show="total > 0"
                  :total="total"
                  :page.sync="queryParams.pageNum"
                  :limit.sync="queryParams.pageSize"
                  @pagination="getList"
                />
              </div>
            </div>
            <div class="content" v-if="Mode == '收藏岗位'">
              <ul class="content-list" v-if="dataList.length > 0">
                <li
                  class="recommend-job-item"
                  v-for="(item, index) in dataList"
                  :key="index"
                >
                  <a :href="'/jobDetail/' + item.jobId" target="_blank">
                    <div class="job-top-container">
                      <div class="job-top">
                        <h3 class="job-name substring">{{ item.job }}</h3>
                        <h3 class="wage substring">{{ item.startSalary }}</h3>
                      </div>
                      <div class="job-bottom substring">
                        <span class="tag" v-if="item.workingPlace">{{
                          item.workingPlace
                        }}</span
                        ><span class="tag" v-if="item.educationName">{{
                          item.educationName
                        }}</span
                        ><span class="tag" v-if="item.serviceName">{{
                          item.serviceName
                        }}</span>
                      </div>
                      <div class="job-bottom substring">
                        <span
                          v-for="(ite, i) in item.disabilities"
                          class="block"
                          :style="{ backgroundColor: getTagColor(ite) }"
                          >{{ ite }}</span
                        >
                      </div>
                    </div>
                  </a>
                  <div class="company-bottom">
                    <div class="company-desc">
                      <a
                        :href="'/companyDetail/' + item.companyId"
                        target="_blank"
                        class="company-t"
                      >
                        <img
                          v-if="item.reCompanyLogo"
                          :src="item.reCompanyLogo"
                          alt=""
                          class="company-logo"
                        />
                        <div
                          v-else
                          class="company-title"
                          :style="{
                            backgroundColor: getColorById(item.companyId),
                          }"
                        >
                          {{ item.companyName.slice(0, 4) }}
                        </div>
                        <div class="company-name substring">
                          {{ item.companyName }}
                        </div>
                      </a>
                    </div>
                  </div>
                </li>
              </ul>
              <div class="empty-page" v-else>
                <div class="empty-tip">您还没有收藏的岗位，建议您主动！</div>
                <button type="button" class="ant-btn ant-btn-primary empty-btn">
                  <router-link to="/jobs">搜索职位</router-link>
                </button>
              </div>
              <!-- 分页器 -->
              <div class="pagination-wrapper">
                <pagination
                  v-show="total > 0"
                  :total="total"
                  :page.sync="queryParams.pageNum"
                  :limit.sync="queryParams.pageSize"
                  @pagination="JobCollectList"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  <script>
import {
  getJobCollectList,
  getCompanyCollectList,
  getDisabledStatus,
  getPreviewUrl,
} from "@/api/index";
import {
  getTagColor,
  getColorById,
  formatDisabilityData,
} from "@/helper/utilities";
import { groupBy } from "lodash";
export default {
  name: "follow",
  data() {
    return {
      Mode: "关注企业",
      tabs: ["关注企业", "收藏岗位"],
      queryParams: {
        pageNum: 1,
        pageSize: 10,
      },
      dataList: [],
      // 总条数
      total: 0,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getTagColor,
    getColorById,
    toggleLoginMode(mode) {
      this.Mode = mode;
      this.dataList = [];
      if (mode != "关注企业") {
        this.JobCollectList();
      } else {
        this.getList();
      }
    },

    getList() {
      const loading = this.$loading();
      getCompanyCollectList(this.queryParams)
        .then(async (res) => {
          loading.close();
          this.dataList = res.rows;
          this.dataList.forEach(async (item, i) => {
            if (item.reCompanyLogo) {
              await this.PreviewLogoUrl(item.reCompanyLogo, i);
            }
          });
          this.total = res.total;
        })
        .catch(() => {
          loading.close();
        });
    },

    JobCollectList() {
      const loading = this.$loading();
      getJobCollectList(this.queryParams)
        .then(async (res) => {
          loading.close();
          if (res.code == 200) {
            // 1. 提取所有 jobId
            let jobIds = res.rows.map((item) => item.jobId);
            // 2. 根据 jobIds 异步获取残疾标签数据
            await this.fetchDisabilityLabels(res.rows, jobIds);
            this.total = res.total;
          }
        })
        .catch(() => {
          loading.close();
        });
    },

    //3，获取对应数据的残疾标签
    fetchDisabilityLabels(dataList, jobIds) {
      if (jobIds.length > 0) {
        getDisabledStatus(jobIds).then((res) => {
          const result = {};
          Object.keys(res.data).forEach((jobId) => {
            const grouped = groupBy(res.data[jobId], "disabledType");
            result[jobId] = Object.entries(grouped).map(([type, items]) => ({
              disabledType: type,
              disabledLevel: [
                ...new Set(items.map((item) => item.disabledLevel)),
              ],
            }));
          });

          const formattedData = formatDisabilityData(result);
          this.dataList = dataList.map((job, i) => {
            if (job.reCompanyLogo) {
              this.PreviewLogoUrl(job.reCompanyLogo, i);
            }
            // 找到当前jobId对应的残疾数据
            const disabilities = formattedData[job.jobId] || [];
            return {
              ...job,
              disabilities, // 将残疾数据添加到职位对象中
            };
          });
        });
      } else {
        this.dataList = [];
      }
    },

    //获取岗位列表公司logo
    async PreviewLogoUrl(reCompanyLogo, i) {
      await getPreviewUrl(reCompanyLogo).then((response) => {
        this.dataList[i].reCompanyLogo = response.msg;
      });
    },
  },
};
</script>
  <style lang="less" scoped>
.banner {
  background-image: url("../assets/images/czqypc.png");
  background-size: 100% 100%;
  padding-bottom: 32%;
  background-repeat: no-repeat;
}
.profile {
  width: @main-width;
  margin: auto;
  &-header {
    padding-top: 50px;
    margin-bottom: 50px;
    .title {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .cont_tit {
      position: relative;
      font-weight: 800;
    }

    .cont_tit:after {
      content: "";
      position: absolute;
      background: url("../assets/images/index20231114_8.png") center center
        no-repeat;
      background-size: 100% auto;
      width: 450px;
      height: 56px;
      left: -10px;
      bottom: -30px;
    }

    .cont_tit p {
      display: inline-block;
      font-size: 30px;
      padding-right: 20px;
      line-height: 1.1;
      position: relative;
      margin-right: 20px;
      font-weight: 600;
      color: #335593;
    }

    .cont_tit p:after {
      content: "";
      position: absolute;
      height: 28px;
      width: 3px;
      left: 100%;
      bottom: 0;
      background: #7499ce;
    }

    .cont_tit span {
      display: inline-block;
      font-size: 14px;
      color: #b1b1b1;
    }
    .title .crumb {
      color: #585858;
      font-size: 18px;
    }

    .title .crumb a {
      margin: 0 10px;
      display: inline-block;
    }
  }
  &-conter {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 20px;
    .job-tab {
      align-items: center;
      border-bottom: 1px solid #7499ce;
      display: -ms-flexbox;
      display: flex;
      height: 62px;
      justify-content: space-around;
      line-height: 62px;
      margin-bottom: 10px;
      width: 100%;
      .tab-item {
        cursor: pointer;
        display: block;
        font-size: 18px;
        font-weight: 500;
        height: 62px;
        line-height: 62px;
        position: relative;
      }
      .tab-item.item--active {
        color: #7499ce;
        font-weight: bold;
      }
      .tab-item.item--active:after {
        content: "";
        position: absolute;
        width: 18px;
        height: 18px;
        border-color: #7499ce #7499ce #fff #fff;
        border-style: solid;
        border-width: 1px;
        top: calc(100% - 0.49em);
        left: 50%;
        background: #fff;
        transform: rotate(-45deg) translateX(-50%) translateY(-50%);
      }
    }
  }
  .resumeForm {
    margin: 30px 0;
    background: #fff;
    box-shadow: 0px 9px 20px 0px #c2c1c180;
    border-radius: 4px;
    padding: 30px;
    .ant-spin-nested-loading {
      position: relative;
      .ant-spin-container {
        position: relative;
        -webkit-transition: opacity 0.3s;
        -o-transition: opacity 0.3s;
        transition: opacity 0.3s;
        .empty-page {
          background-color: #fff;
          background-image: url(data:image/png;base64,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);
          background-position: center 104px;
          background-repeat: no-repeat;
          background-size: 140px 168px;
          height: 480px;
          text-align: center;
          .empty-tip {
            -webkit-transform: translateY(302px);
            -ms-transform: translateY(302px);
            /* transform: translateY(302px); */
          }
          .empty-btn {
            -webkit-transform: translateY(332px);
            -ms-transform: translateY(332px);
            transform: translateY(332px);
          }
          .ant-btn {
            background-image: none;
            background: #fff;
            border: 1px solid #d9d9d9;
            border-radius: 4px;
            -webkit-box-shadow: 0 2px 0 rgba(0, 0, 0, 0.015);
            box-shadow: 0 2px 0 rgba(0, 0, 0, 0.015);
            color: #333;
            cursor: pointer;
            display: inline-block;
            font-size: 14px;
            font-weight: 400;
            height: 32px;
            line-height: 1.5715;
            padding: 4px 15px;
            position: relative;
            text-align: center;
            -ms-touch-action: manipulation;
            touch-action: manipulation;
            -webkit-transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
            -o-transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
            transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
            -webkit-user-select: none;
            -moz-user-select: none;
            -ms-user-select: none;
            user-select: none;
            white-space: nowrap;
          }
          .ant-btn-primary {
            background: #00a0e9;
            border-color: #00a0e9;
            -webkit-box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045);
            box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045);
            color: #fff;
            text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.12);
          }
        }
        .recommend-job-item {
          background-color: #fafbfd;
          box-shadow: 0 2px 10px rgba(54, 97, 174, 0.1);
          border-radius: 8px;
          -webkit-box-sizing: content-box;
          box-sizing: content-box;
          margin-bottom: 21px;
          padding: 13px 25px;
          width: @main-width;
        }
      }
      .ant-spin-container:after {
        background: #fff;
        bottom: 0;
        content: "";
        display: none\9;
        height: 100%;
        left: 0;
        opacity: 0;
        pointer-events: none;
        position: absolute;
        right: 0;
        top: 0;
        -webkit-transition: all 0.3s;
        -o-transition: all 0.3s;
        transition: all 0.3s;
        width: 100%;
        z-index: 10;
      }
    }

    .pagination-wrapper {
      text-align: center;
    }
  }
}
</style>
    